export default "__VITE_ASSET__8UkL4otY__"